import { createContext } from 'react'
import { useTranslation } from 'react-i18next'
import BupLoading from '@BUP/components/Loading/Main'
import ErrorMessage from '@BUP/components/Error/Message'
import { useGetCurrent } from '@BUP/hooks/Current/useGetCurrent'
import { BraveupEnrollmentWrapper } from './BraveupEnrollmentWrapper'
import { useEnrollmentTracking } from '@BUP/hooks/tracking/useEnrollmentTracking'

export const EnrollmentContext = createContext()

export const EnrollmentContextProvider = ({ children }) => {
  const i18n = useTranslation()

  const {
    data: enrollment,
    isLoading: loading,
    error: enrollmentError
  } = useGetCurrent('current-user/current-enrollment', 3)

  const {
    data: role,
    isLoading: roleLoading,
    error: roleError
  } = useGetCurrent('current-enrollment/role', 3)

  useEnrollmentTracking(enrollment, role)

  if (loading || roleLoading) return <BupLoading />

  if (enrollmentError || roleError) {
    return (
      <ErrorMessage
        message={i18n.t('common.resources.enrollment.actions.read.failure', { context: 'support' })}
        withSignOut
      />
    )
  }

  if (!enrollment || !role) return null

  return (
    <EnrollmentContext.Provider value={enrollment}>
      <BraveupEnrollmentWrapper
        enrollment={enrollment}
        role={role}
        roleLoading={roleLoading}
      >
        {children}
      </BraveupEnrollmentWrapper>
    </EnrollmentContext.Provider>
  )
}
